var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.12,
    height: 32.97,
    viewBox: "0 0 47.12 33.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7897",
    "data-name": "Grupo 7897",
    transform: "translate(-581.906 -406.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5481",
    "data-name": "Caminho 5481",
    d: "M-2542.636-1489.286c.137-1.378.45-1.837,1.232-1.854s1.128.441,1.312,1.831h12.988c0-.185-.007-.372,0-.558a1.244,1.244,0,0,1,1.271-1.273,1.236,1.236,0,0,1,1.2,1.3c0,.166,0,.332,0,.559h.429c1.288,0,2.576,0,3.864,0a5.2,5.2,0,0,1,5.273,5.266q.01,10.8,0,21.608a5.178,5.178,0,0,1-5.221,5.233q-13.333.014-26.666,0a5.171,5.171,0,0,1-5.22-5.233q-.015-10.843,0-21.686a5.207,5.207,0,0,1,5.2-5.189c1.3-.009,2.6,0,3.9,0Zm-7.063,10.627v.421q0,7.847,0,15.695a2.746,2.746,0,0,0,2.937,2.953l26.281,0a2.737,2.737,0,0,0,2.942-2.942q0-7.847,0-15.695v-.429Zm32.161-2.513c0-.941,0-1.853,0-2.765a2.73,2.73,0,0,0-2.858-2.873c-1.288,0-2.577,0-3.865,0-.112,0-.223.014-.369.023,0,.2,0,.379,0,.557a1.238,1.238,0,0,1-1.224,1.274,1.25,1.25,0,0,1-1.246-1.262c-.009-.188,0-.377,0-.562h-13.01c-.014.275-.006.522-.043.762a1.227,1.227,0,0,1-1.308,1.059,1.241,1.241,0,0,1-1.138-1.2c-.009-.2,0-.405,0-.615a1.431,1.431,0,0,0-.188-.031c-1.443,0-2.886-.024-4.328.007a2.541,2.541,0,0,0-2.483,2.149,31.927,31.927,0,0,0-.027,3.479Z",
    transform: "translate(3134.085 1897.891)",
    fill: "#f37922"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.33392a8a.svg";
export { ForwardRef as ReactComponent };